/**
 * Whether somebody walks a verification by its divergences alone (#641).
 *
 * Kept with the person, under `preferences.divergenceOnly`, as the queue's
 * filters are: the same pharmacist on the counter machine and on their laptop
 * is one pharmacist. A copy is kept in this browser too, so the screen opens
 * in the right pass at once instead of switching under somebody's eyes when
 * the account answers.
 *
 * Off until chosen: the full pass is the record that every entry was looked
 * at, and leaving it is a choice somebody makes, not one made for them.
 */
export const PREFERENCE_KEY = 'divergenceOnly'
const CACHE_KEY = `review.${PREFERENCE_KEY}`

/** What the account holds, if it holds anything this side understands. */
export function fromPreferences(
  preferences: Readonly<Record<string, unknown>>,
): boolean | undefined {
  const saved = preferences[PREFERENCE_KEY]
  return typeof saved === 'boolean' ? saved : undefined
}

/*
 * Both ways wrapped: a private window, or a browser set to refuse site data,
 * throws on `localStorage` itself. Then the account alone decides, a moment
 * later.
 */
export function cachedDivergenceOnly(storage: Pick<Storage, 'getItem'> | undefined): boolean {
  try {
    return storage?.getItem(CACHE_KEY) === 'true'
  } catch {
    return false
  }
}

export function cacheDivergenceOnly(
  storage: Pick<Storage, 'setItem'> | undefined,
  on: boolean,
): void {
  try {
    storage?.setItem(CACHE_KEY, String(on))
  } catch {
    // Nothing cached: the next visit waits for the account instead.
  }
}
